import { Loader } from '.'

const mapStateToProps = (state, ownProps) => {
  const {
    isPrimary = false,
    isDisabled = false,
    isSubmit = false,
    label,
    children,
    busy,
    onClick,
    key,
    style = {},
    reference = null,
  } = ownProps

  return { isPrimary, isDisabled, isSubmit, label, children, busy, onClick, key, style, reference }
}

class Button extends Component {
  render() {
    const {
      isPrimary,
      isDisabled,
      isSubmit,
      label,
      children,
      busy,
      onClick,
      key,
      style,
      reference,
    } = this.props
    return (
      <button
        type={isSubmit ? 'submit' : 'button'}
        key={key}
        onClick={() => {
          if (!onClick) return
          onClick()
        }}
        className={`btn btn-sm ${isPrimary ? 'btn-primary' : 'btn-secondary'}`}
        disabled={isDisabled}
        style={{ position: 'relative', ...style }}
        ref={reference}
      >
        {label || children}
        {busy && <Loader size="sm" style={{ position: 'absolute', top: '12px', right: '10px' }} />}
      </button>
    )
  }
}

export default connect(mapStateToProps)(Button)
